import { createAction, props } from '@ngrx/store';
import {Item} from '@emm/core/models/item.model';

export enum ItemGroupingsAction {
    LoadItemGroups = '[Item Groupings Management] Load Item Groups',
    LoadItemGroupsSuccess = '[Management API] Load Item Groups Success',
    LoadItemGroupsFailure = '[Management API] Load Item Groups Failure',
    Select = '[Item Groupings Management] Select Item Grouping',
    LoadAllChildItems = '[Item Groupings Management] Load All Child Items From Item Groupings',
    LoadAllChildItemsSuccess = '[Management API] Load All Child Items From Item Groupings Success',
    LoadAllChildItemsFailure = '[Management API] Load All Child Items From Item Groupings Failure',
    ToggleDisabled = '[Item Groupings Management] Toggle Item Grouping Disabled',
    ToggleDisabledSuccess = '[Management API] Toggle Item Grouping Disabled Success',
    ToggleDisabledFailure = '[Management API] Toggle Item Grouping Disabled Failure',
    AddChildItem = '[Item Groupings Management] Add Item Group Child Item',
    AddChildItemSuccess = '[Management API] Add Item Group Child Item Success',
    AddChildItemFailure = '[Management API] Add Item Group Child Item Failure',
    DeleteItemGroup = '[Item Groupings Management] Delete Item Group',
    DeleteItemGroupSuccess = '[Management API] Delete Item Group Success',
    DeleteItemGroupFailure = '[Management API] Delete Item Group Failure',
    RemoveChildItem = '[Item Groupings Management] Remove Item Group Child Item',
    RemoveChildItemSuccess = '[Management API] Remove Item Group Child Item Success',
    RemoveChildItemFailure = '[Management API] Remove Item Group Child Item Failure'
}

export const ItemGroupingsActions = {
    loadItemGroups: createAction(ItemGroupingsAction.LoadItemGroups),
    loadItemGroupsSuccess: createAction(ItemGroupingsAction.LoadItemGroupsSuccess, props<{ items: Item[] }>()),
    loadItemGroupsFailure: createAction(ItemGroupingsAction.LoadItemGroupsFailure, props<{ error: any }>()),
    select: createAction(ItemGroupingsAction.Select, props<{ tag: string }>()),
    loadAllChildItems: createAction(ItemGroupingsAction.LoadAllChildItems, props<{ id: string }>()),
    loadAllChildItemsSuccess: createAction(
        ItemGroupingsAction.LoadAllChildItemsSuccess,
        props<{ items: Item[] }>()
    ),
    loadAllChildItemsFailure: createAction(ItemGroupingsAction.LoadAllChildItemsFailure, props<{ error: any }>()),
    toggleDisabled: createAction(ItemGroupingsAction.ToggleDisabled, props<{ tag: string; enabled: boolean }>()),
    toggleDisabledSuccess: createAction(ItemGroupingsAction.ToggleDisabledSuccess),
    toggleDisabledFailure: createAction(ItemGroupingsAction.ToggleDisabledFailure, props<{ error: any }>()),
    addChildItem: createAction(
        ItemGroupingsAction.AddChildItem,
        props<{ parentTag: string; children: Item[]; isGlobalAdd: boolean }>()
    ),
    addChildItemSuccess: createAction(ItemGroupingsAction.AddChildItemSuccess),
    addChildItemFailure: createAction(ItemGroupingsAction.AddChildItemFailure, props<{ error: any }>()),
    deleteItemGroup: createAction(ItemGroupingsAction.DeleteItemGroup, props<{ tag: string }>()),
    deleteItemGroupSuccess: createAction(ItemGroupingsAction.DeleteItemGroupSuccess),
    deleteItemGroupFailure: createAction(ItemGroupingsAction.DeleteItemGroupFailure, props<{ error: any }>()),
    removeChildItem: createAction(
        ItemGroupingsAction.RemoveChildItem,
        props<{ parentTag: string; childTag: string; }>()
    ),
    removeChildItemSuccess: createAction(ItemGroupingsAction.RemoveChildItemSuccess),
    removeChildItemFailure: createAction(ItemGroupingsAction.RemoveChildItemFailure, props<{ error: any }>())
};

export const AsyncActions = {
    loadActions: [
        ItemGroupingsActions.loadItemGroups,
        ItemGroupingsActions.loadAllChildItems,
        ItemGroupingsActions.toggleDisabled,
        ItemGroupingsActions.addChildItem,
        ItemGroupingsActions.deleteItemGroup,
        ItemGroupingsActions.removeChildItem
    ],
    successActions: [
        ItemGroupingsActions.loadItemGroupsSuccess,
        ItemGroupingsActions.loadAllChildItemsSuccess,
        ItemGroupingsActions.toggleDisabledSuccess,
        ItemGroupingsActions.addChildItemSuccess,
        ItemGroupingsActions.deleteItemGroupSuccess,
        ItemGroupingsActions.removeChildItemSuccess
    ],
    errorActions: [
        ItemGroupingsActions.loadItemGroupsFailure,
        ItemGroupingsActions.loadAllChildItemsFailure,
        ItemGroupingsActions.toggleDisabledFailure,
        ItemGroupingsActions.addChildItemFailure,
        ItemGroupingsActions.deleteItemGroupFailure,
        ItemGroupingsActions.removeChildItemFailure
    ]
};
